// extracted by mini-css-extract-plugin
export default {"card":"SelectCard_card__NEhLi","card__subtitle":"SelectCard_card__subtitle__mdXfn","card__amount":"SelectCard_card__amount__+DPbC","card_disabled":"SelectCard_card_disabled__vxGf6"};